import React from 'react';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <section className="py-10 px-4 relative z-10" data-id="element-85">
      <div className="max-w-3xl mx-auto surface-gradient border border-gold-primary/30 rounded-2xl p-6 md:p-10 text-center relative overflow-hidden" data-id="element-86">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-primary to-transparent" data-id="element-87"></div>

        <ShieldCheck className="w-12 h-12 text-gold-light mx-auto mb-4" data-id="element-88" />

        <h2 className="font-cormorant text-3xl md:text-4xl text-text-primary mb-3" data-id="element-89">
          Compra 100% sin riesgo 🛡️
        </h2>
        <h3 className="text-xl text-gold-primary font-medium mb-4" data-id="element-90">
          Garantía de satisfacción — 7 días
        </h3>

        <p className="text-text-soft text-lg leading-relaxed" data-id="element-91">
          Si en los próximos 7 días sentís que el grimorio no es para vos, nos
          escribís y te devolvemos el 100% de tu dinero. Sin preguntas, sin
          vueltas. Porque sabemos que cuando lo abras, no vas a querer soltarlo.
        </p>
      </div>
    </section>;
};